import React from 'react'

import ModalFooterActionContainer from '../TripModal/TripItems/Create/ModalFooterActionContainer'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'

interface Props {
  updateTripDates: () => void
  currentTripDates: string
  extendedTripDates: string
  isLoading: boolean
}

function ConfirmUpdateTripDatesModal(props: Props) {
  const { updateTripDates, isLoading, currentTripDates, extendedTripDates } =
    props

  const { closeModal, goBack } = useModalCallbacks()
  const isMobile = useScreenSizeOnly('mobile')

  return (
    <>
      <ModalHeader
        title="Extend trip duration"
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={12}>
            <BodyTextBlock variant="large">
              Please check the new dates for your trip
            </BodyTextBlock>
            <div>
              <BodyTextBlock variant="large">
                <b>Current trip dates: </b> {currentTripDates}
              </BodyTextBlock>
              <BodyTextBlock variant="large">
                <b>New trip dates:</b> {extendedTripDates}
              </BodyTextBlock>
            </div>
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <ModalFooterActionContainer>
          <TextButton
            kind="secondary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={closeModal}
          >
            Cancel
          </TextButton>
          <TextButton
            kind="primary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={updateTripDates}
            disabled={isLoading}
          >
            Confirm new trip dates
          </TextButton>
        </ModalFooterActionContainer>
      </ModalFooter>
    </>
  )
}

export default ConfirmUpdateTripDatesModal
